import { Badge as UIBadge } from "@webmotors/eleanor-ui";
import { classNames } from "../../support/formatters/class-formatter";

import styles from "./badge.module.css";

export type BadgeVariantProps =
  | 'primary'
  | 'complementary'
  | 'success'
  | 'successLight'
  | 'neutral'
  | 'darkTransparent'
  | 'dark';

type BadgeSizeProps = "small" | "medium";

export interface BadgeComponentProps
  extends React.HTMLAttributes<HTMLDivElement> {
  variant: BadgeVariantProps;
  text: string;
  icon?: React.ReactNode;
  size?: BadgeSizeProps;
  className?: string;
  dataTestid?: string;
  isUppercase?: boolean;
  isOutlined?: boolean;
}

export function Badge({
  text,
  variant,
  icon,
  size,
  className,
  dataTestid,
  isUppercase = false,
  isOutlined = false,
  ...props
}: Readonly<BadgeComponentProps>) {
  return (
    <UIBadge
      text={text}
      variant={variant}
      icon={icon}
      size={size}
      className={classNames(styles.Badge, className)}
      dataTestid={dataTestid}
      isUppercase={isUppercase}
      isOutlined={isOutlined}
      {...props}
    />
  );
}
